export const TALENT_POOL_MODEL = "talent-pool";

const talentPoolModel = {
  name: "",
  users: {
    jsonApi: "hasMany",
    type: "users"
  }
};

export default talentPoolModel;
